import { FC, useCallback } from 'react';

import { Dropdown, FieldLabel, FlexColumn } from '@portal/common/components';

import _ from '../../../locale';
import { NO_BOUND_VALUE } from './CustomAgeGroupSelector';

interface SavedAgeGroupsProps {
    value: string[];
    onChange: (ev: { target: { value: string[] } }) => void;
}

export const AGE_GROUP_SEPARATOR = ' - ';

const customAgeLabelGetter = (o) => (o === NO_BOUND_VALUE ? _('age_group_above') : String(o));

const SavedAgeGroups: FC<SavedAgeGroupsProps> = ({ value, onChange }) => {
    const handleClear = useCallback(() => {
        onChange({ target: { value: [] } });
    }, [onChange]);

    const ageGroupLabelGetter = useCallback(
        (group) =>
            group
                .split(AGE_GROUP_SEPARATOR)
                .map(customAgeLabelGetter)
                .join(AGE_GROUP_SEPARATOR)
                .replace(AGE_GROUP_SEPARATOR + _('age_group_above'), ` ${_('age_group_above')}`),
        []
    );

    return (
        <FlexColumn itemsSpacing={12}>
            <FieldLabel>{_('export_single_report_selected_aggregates_dropdown_label')}</FieldLabel>
            <Dropdown
                valueMode="multiArray"
                isClearable
                placeholder={_('export_single_report_selected_aggregates_dropdown_placeholder')}
                value={value}
                options={value}
                onClear={handleClear}
                onSelect={onChange}
                onMultiSelect={onChange}
                onRemove={onChange}
                optionLabelGetter={ageGroupLabelGetter}
            />
        </FlexColumn>
    );
};

export default SavedAgeGroups;
